import React from 'react';
import { BrandHeader } from './components/BrandHeader';
import { Hero } from './components/Hero';
import { TrustNumbers } from './components/TrustNumbers';
import { TestimonialGrid } from './components/TestimonialGrid';
import { PainSection } from './components/PainSection';
import { ProductBreakdown } from './components/ProductBreakdown';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { SocialProofToast } from './components/SocialProofToast';
import { SectionHeading } from './components/ui/SectionHeading';
import { HERO_TESTIMONIALS, MORE_TESTIMONIALS } from './data/content';
export function App() {
  return <div className="min-h-full w-full bg-canvas pb-20" data-id="element-0" data-mp="23utbk3a460as">
      <BrandHeader data-id="element-1" data-mp="3ikh8gaq64uzi" />

      <main data-id="element-2" data-mp="3iiweonbohg2p">
        <Hero data-id="element-3" data-mp="3ij61y35c994p" />
        <TrustNumbers data-id="element-4" data-mp="3ijpcuzwkmx98" />

        <section className="bg-canvas py-12" data-id="element-5" data-mp="3mlj9mx3nbh44">
          <div className="mx-auto max-w-page px-5" data-id="element-6" data-mp="3mkhofzsx1e8o">
            <SectionHeading eyebrow="Lo que dicen" title="Gente con la misma rutina que vos" data-id="element-7" data-mp="3rc9e8848zfxr" />
            <div className="mt-7" data-id="element-8" data-mp="3relwkmdx3sbc">
              <TestimonialGrid items={HERO_TESTIMONIALS} data-id="element-9" data-mp="6801qozk67w" />
            </div>
          </div>
        </section>

        <PainSection data-id="element-10" data-mp="2zm4xcjfp5b1a" />
        <ProductBreakdown data-id="element-11" data-mp="2zmwif0bo3qdb" />
        <Bonuses data-id="element-12" data-mp="2znfy0adui2o6" />
        <Pricing data-id="element-13" data-mp="33mf6g4yschkd" />

        <section className="bg-canvas pb-14" data-id="element-14" data-mp="33nq6btp41567">
          <div className="mx-auto max-w-page px-5" data-id="element-15" data-mp="33orla998ybt7">
            <SectionHeading eyebrow="Más resultados" title="No te lo decimos nosotros" data-id="element-16" data-mp="38kqc03i1s5ws" />
            <div className="mt-7" data-id="element-17" data-mp="3dl4lzr37lpxg">
              <TestimonialGrid items={MORE_TESTIMONIALS} data-id="element-18" data-mp="3dmfmni1cyhkc" />
            </div>
          </div>
        </section>

        <Guarantee data-id="element-19" data-mp="nvan5e2e2r9s" />
        <CostOfInaction data-id="element-20" data-mp="sunby4ctm8f0" />
        <FinalCTA data-id="element-21" data-mp="su42lc18kscl" />
      </main>

      <Footer data-id="element-22" data-mp="st2gmciomlg3" />
      <SocialProofToast data-id="element-23" data-mp="ssstcwp0use3" />
      <StickyCta data-id="element-24" data-mp="36hw15qrsq0p" />
    </div>;
}